import { ListChecks } from "lucide-react";

/** Props for the StageRequiredFieldsChip component. */
interface StageRequiredFieldsChipProps {
  labels: string[];
}

/**
 * Board column header chip counting the fields a stage requires, listing them on hover.
 * @param labels - The labels of the stage's required fields
 * @returns The chip, or null when the stage requires nothing
 */
export function StageRequiredFieldsChip({
  labels,
}: StageRequiredFieldsChipProps) {
  if (labels.length === 0) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap text-[11px] font-medium text-muted-foreground"
      title={`Required: ${labels.join(", ")}`}
    >
      <ListChecks className="h-3 w-3" aria-hidden="true" />
      {labels.length} required
    </span>
  );
}
